import { Box, Link, Typography } from '@material-ui/core';
import React, { useEffect, useState, useRef } from 'react';
import { Modal } from 'reactstrap';
import CustomModalFooter from './CustomModalFooter';
import CustomModalHeader from './CustomModalHeader';
import useStyle from './style';
import CustomCloseIcon from './CustomCloseIcon';

const CustomModal = props => {
    const containerRef = useRef(null);
    const isReady = Boolean((props.header?.text || props.titleText) && props.description);
    const [open, setOpen] = useState(props.open);
    const reactId = useRef(Math.random().toString(36).slice(2, 9));

    const toggle = () => {
        setOpen(!open);
        props.toggle && props.toggle();
    };
    useEffect(() => {
        setOpen(props.open);
    }, [props]);

    const styles = useStyle();
    const modalBaseId = props.id || `custom-modal-${reactId.current}`;
    const titleId = props.header?.text || props.titleText || '';
    const descriptionId = props.description || '';

    useEffect(() => {
        if (open && isReady && props.header?.center == false) {
            const timer = setTimeout(() => {
                if (containerRef.current) {
                    containerRef.current.focus();
                }
            }, 100);

            return () => clearTimeout(timer);
        }
    }, [open, isReady, props.header?.center]);

    return (
        <Modal
            id={modalBaseId}
            isOpen={open}
            toggle={toggle}
            modalTransition={{ timeout: 300 }}
            wrapClassName={styles.modalWrapper}
            modalClassName={styles.modalClass}
            aria-label={props.ariaLabel ?? ''}
            role='dialog'
            aria-modal='true'
            aria-labelledby={titleId}
            aria-describedby={descriptionId}
            ref={containerRef}
            aria-busy={!isReady}
            tabIndex={-1}
            centered
        >
            <Box className={styles.modalBoxStyles}>
                {props.header?.center ? (
                    <div className={styles.headerModal}>
                        <div className='modal-header-text'>
                            <Typography
                                role='heading'
                                aria-level={2}
                                component='h2'
                                variant='h2'
                                style={
                                    props.header?.center
                                        ? { textAlign: 'center', width: '100%' }
                                        : {}
                                }
                                id={titleId}
                                tabIndex={-1}
                            >
                                {props.header?.text}
                            </Typography>

                            <div className='modal-header-line'></div>
                        </div>
                    </div>
                ) : (
                    <CustomModalHeader
                        headerText={props.header?.text}
                        center={props.header?.center}
                        arrowAction={props.header?.arrowAction}
                        ariaLabel={props?.header?.ariaLabel}
                        styles={styles}
                        id={titleId}
                    />
                )}
                <Box>
                    {props.closeIconAction && (
                        <CustomCloseIcon closeIconAction={props.closeIconAction} styles={styles} />
                    )}
                </Box>

                <Box
                    style={{ flex: 1, position: 'relative' }}
                    className={'custom-modal-body'}
                    id={descriptionId}
                >
                    {props.children}
                </Box>

                <CustomModalFooter
                    cta1={props.cta1}
                    cta2={props.cta2}
                    link={props.link}
                    setLinkStatus={props.setLinkStatus}
                    apiError={props.apiError}
                    styles={styles}
                />
            </Box>
        </Modal>
    );
};

export default CustomModal;
